import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import setComponentValues from 'helpers/fovPreview/setComponentValues'
import constrainedImageSize from 'helpers/fovPreview/constrainedImageSize'
import { convertToOriginal, convertToScaled } from 'helpers/fovPreview/convert'

const isLargeAngle = angle => angle > 180

class ViewImage extends React.Component {
  state = { containerHeight: null, containerWidth: null }

  updateDimensions = _ => {
    const containerHeight = this.refs.container.clientHeight
    const containerWidth = this.refs.container.clientWidth
    this.setState({ containerHeight, containerWidth, ...setComponentValues({ prevState: Object.assign(this.state, { containerWidth, containerHeight }), ...this.props }) })
  }

  componentDidMount = _ => {
    const containerHeight = this.refs.container.clientHeight
    const containerWidth = this.refs.container.clientWidth
    const backgroundPosition = convertToScaled({ containerWidth, containerHeight, ...this.props })
    this.setState({ containerHeight, containerWidth, ...setComponentValues({ prevState: { containerWidth, containerHeight, backgroundPosition }, ...this.props }) })
    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount = _ => {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentWillReceiveProps(newProps) {
    const { streetViewActive, fovMode, horizontalAngleOfView, horizontalResolution, scene, currentCameraId,
      backgroundPosition: { backgroundPositionX, backgroundPositionY }, userUploadedSceneActive, batchUpdateCalculatorAction, aspectRatio } = newProps

    const cameraChanged = currentCameraId !== this.props.currentCameraId

    if (fovMode !== this.props.fovMode || horizontalAngleOfView !== this.props.horizontalAngleOfView || horizontalResolution !== this.props.horizontalResolution || scene !== this.props.scene) {
      const { backgroundPosition, ...rest } = setComponentValues({ prevState: this.state, cameraChanged, ...newProps })

      this.setState({ backgroundPosition, ...rest })
      if (!cameraChanged) batchUpdateCalculatorAction({ backgroundPosition: convertToOriginal({ ...backgroundPosition, ...this.state, aspectRatio }) }, ['backgroundPosition'], this.props.id, false)
    } else if (backgroundPositionX !== this.props.backgroundPosition.backgroundPositionX || backgroundPositionY !== this.props.backgroundPosition.backgroundPositionY) {
      this.setState({ ...setComponentValues({ prevState: this.state, cameraChanged, ...newProps }) })
    }

    if (streetViewActive !== this.props.streetViewActive && streetViewActive === true && !userUploadedSceneActive && !cameraChanged) {
      // ensure that background size is taken from whatever camera is coming in through props
      const { backgroundSize: { backgroundSizeX, backgroundSizeY } } = setComponentValues({ prevState: this.state, ...newProps })
      const backgroundPosition = { backgroundPositionX: -(backgroundSizeX - this.state.containerWidth) / 2, backgroundPositionY: -(backgroundSizeY - this.state.containerHeight) / 2 }

      this.setState({ backgroundPosition })
      batchUpdateCalculatorAction({ backgroundPosition: convertToOriginal({ ...backgroundPosition, ...this.state, aspectRatio }) }, ['backgroundPosition'], this.props.id, false)
    }
  }

  dragStart = (event) => {
    const { backgroundPosition: { backgroundPositionX, backgroundPositionY } } = this.state

    if (event.type === 'mousedown') {
      this.dragStartX = event.clientX
      this.dragStartY = event.clientY
    } else {
      const touch = event.touches[0] || event.changedTouches[0]
      this.dragStartX = touch.pageX
      this.dragStartY = touch.pageY
    }

    this.initialBackgroundPositionX = backgroundPositionX
    this.initialBackgroundPositionY = backgroundPositionY
    this.setState({ isDragging: true })
  }

  dragging = (event) => {
    if (!this.state.isDragging) return
    const { initialBackgroundPositionX, initialBackgroundPositionY, dragStartX, dragStartY, state: { width, height, conventional,
      clip, backgroundSize: { backgroundSizeX, backgroundSizeY } }, props: { horizontalAngleOfView, batchUpdateCalculatorAction, id, aspectRatio } } = this

    let clientX, clientY
    if (event.type === 'mousemove') {
      clientX = event.clientX
      clientY = event.clientY
    } else {
      const touch = event.touches[0] || event.changedTouches[0]
      clientX = touch.pageX
      clientY = touch.pageY
    }

    const { backgroundPositionX, backgroundPositionY } = constrainedImageSize({
      conventional, clip, width, height,
      backgroundSize: { backgroundSizeX, backgroundSizeY },
      backgroundPosition: {
        backgroundPositionX: initialBackgroundPositionX - (dragStartX - clientX),
        backgroundPositionY: initialBackgroundPositionY - (dragStartY - clientY)
      }, horizontalAngleOfView, aspectRatio
    })
    batchUpdateCalculatorAction({ backgroundPosition: convertToOriginal({ backgroundPositionX, backgroundPositionY, ...this.state, aspectRatio }) }, ['backgroundPosition'], id, false)
    this.setState({
      backgroundPosition: { backgroundPositionX, backgroundPositionY }
    })
  }

  dragEnd = _ => {
    this.setState({ isDragging: false })
  }

  onDragging = e => !this.state.isDragging || this.dragging(e)

  render() {
    const { onDragging, dragStart, dragEnd, state: { backgroundSize, backgroundPosition,
      conventional, clip, containerHeight, containerWidth }, props: { horizontalAngleOfView, scene, classes } } = this
    return (
      <div className={classes.container} ref='container'>
        { containerHeight && containerWidth &&
          <div
            className={classes.image}
            style={Object.assign(
              {
                backgroundSize: `${isLargeAngle(horizontalAngleOfView) ? containerWidth : backgroundSize.backgroundSizeX}px ${isLargeAngle(horizontalAngleOfView) ? containerHeight : backgroundSize.backgroundSizeY}px`,
                backgroundPosition: `${backgroundPosition.backgroundPositionX}px ${backgroundPosition.backgroundPositionY}px`
              },
              !EXPORT && { backgroundImage: `url(${scene})` }
            )}
            onMouseDown={dragStart}
            onTouchStart={dragStart}
            onMouseMove={onDragging}
            onTouchMove={onDragging}
            onMouseUp={dragEnd}
            onTouchEnd={dragEnd}
            ref='sceneContainer'
          >
            <div className={conventional ? classes.topClip : classes.rightClip} style={{ [conventional ? 'height' : 'width']: clip }} />
            <div className={conventional ? classes.bottomClip : classes.leftClip} style={{ [conventional ? 'height' : 'width']: clip }} />
          </div>
        }
      </div>
    )
  }
}

export default injectSheet(style)(ViewImage)



// WEBPACK FOOTER //
// ./src/components/BottomBar/SimulatedView/ViewImage/index.js